module.exports = __webpack_public_path__ + "static/wpack/extracted/cocreate-icon9e46a8cc442c9a456d65fd477d7e5fbe.svg";